import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IInvestmentInfo,
  IInvestmentReview,
  IInvestmentConclusion
} from './fund-pension-investment-types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/transactions`
});

export function getInvestmentInfo(
  productId: string,
  portfolioId: string
): Promise<IInvestmentInfo> {
  return http.get(`/v1/investment/fund-pension/${productId}/info`, {
    params: { portfolioId }
  });
}

export function getInvestmentReview(
  productId: string,
  portfolioId: string,
  amount: number
): Promise<IInvestmentReview> {
  return http.get(`/v1/investment/fund-pension/${productId}/review`, {
    params: { portfolioId, amount }
  });
}

export function makeInvestment(
  productApiId: string,
  portfolioApiId: string,
  amount: number
): Promise<IInvestmentConclusion> {
  return http.post(`/v1/investment/fund-pension`, {
    productApiId,
    portfolioApiId,
    amount
  });
}
